import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "u-bg-white u-pad-y-1 u-mar-y-0 o-container__remove" }
const _hoisted_2 = { class: "o-container u-pad-y-1" }
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.link,
        title: _ctx.title,
        target: "_self"
      }, [
        _createElementVNode("img", {
          src: _ctx.banner,
          alt: "altText"
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3)
    ])
  ]))
}